import React from "react";
import "./style.scss";
import { Drawer as AntDrawer } from "antd";
import { CloseIcon } from "assets/icons";

function Drawer({ isOpen, onClose, children, title, className, width = 538 }) {
  return (
    <AntDrawer
      closeIcon={<CloseIcon />}
      title={title}
      onClose={onClose}
      open={isOpen}
      className={className}
      width={width}
    >
      {children}
    </AntDrawer>
  );
}

export default Drawer;
